import React from 'react';
import { Controller } from 'react-hook-form';
import TextInput from '../../../components/form/TextInput';

const Configuration = ({ isEditable, loading, form }) => {
  return (
    <div className="tabs__content pt-30 js-tabs-content">
      <div className="tabs__pane -tab-item-1 is-tab-el-active">
        <div className="overflow-scroll scroll-bar-1">
          <Controller
            control={form.control}
            name="daily_quota"
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                disabled={loading || !isEditable}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                type="number"
                isRequired={true}
                label="Kuota Harian"
                isError={Boolean(form.formState.errors.daily_quota)}
                errorMessage={
                  Boolean(form.formState.errors.daily_quota) &&
                  form.formState.errors.daily_quota.message
                }
              />
            )}
          />
          <Controller
            control={form.control}
            name="operational_email"
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                disabled={loading || !isEditable}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                type="email"
                isRequired={true}
                label="Email Operasional"
                isError={Boolean(form.formState.errors.operational_email)}
                errorMessage={
                  Boolean(form.formState.errors.operational_email) &&
                  form.formState.errors.operational_email.message
                }
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default Configuration;
